<div
  #jobsDropdownTrigger="rtOverlayOrigin"
  [class.active]="jobsDropdown.open"
  (click)="jobsDropdown.open = !jobsDropdown.open; fetchLocationJobs()"
  class="container"
  rt-overlay-origin
>
  <ng-content />
</div>

<ng-template
  #jobsDropdown="rtConnectedOverlay"
  [origin]="jobsDropdownTrigger"
  (backdropClick)="jobsDropdown.open = false"
  rt-connected-overlay
  [positions]="dropdownPositions()"
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.Medium">
    @if (jobsDropdownLoading) {
      <div padding-tb-medium>
        <rt-spinner variant="small" />
      </div>
    }
    @if (!jobsDropdownLoading) {
      <div class="scroll-wrap">
        @for (job of locationJobItems; track trackById($index, job)) {
          <rt-dropdown-item [hasHoverEffect]="job.hasAccess">
            <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ job: job }" />
          </rt-dropdown-item>
        }
      </div>
    }
  </rt-dropdown>
</ng-template>

<ng-template #itemTpl let-job="job">
  <div layout layout-space-between (click)="job.hasAccess ? openJobEditor(job.id) : null">
    <div class="offer-content" layout-vertical>
      <div layout layout-align-items-center>
        <rt-offer-status-indicator
          [offerStatus]="{ kind: 'job', status: job.status }"
          [class.disabled]="!job.hasAccess"
        />
        <span padding-left-small-x [attr.text-disabled]="!job.hasAccess || null">
          {{ job.title }}
        </span>
      </div>
      <div
        padding-left-medium
        [attr.text-color]="job.hasAccess || null"
        [attr.text-disabled]="!job.hasAccess || null"
        text-default
      >
        <rt-assigned-locations-info-container [locationIds]="job.locationIds" />
      </div>
    </div>
    @if (job.hasAccess) {
      <rt-icon sufix name="open-in-new" />
    }
  </div>
</ng-template>
